export default {
  defaultDaysToExpire: 14,
};
